import { useState } from 'react';

/**
 * The results a picker has picked, by id: what its results' checks show and its footer counts.
 * The query, and what the pick is added to, stay the host's.
 */
export function usePickedResources() {
  const [ids, setIds] = useState<ReadonlySet<number>>(() => new Set());
  return { ids, onChange: setIds, clear: () => setIds(new Set()) };
}
